// @file Stores that handles Plans and Upgrade modals
import { Plan as PlanApi } from 'dashboard/padlet_api'
import { Plan } from 'types'
import { Module } from 'vuex'

enum UpgradeStep {
  BelowPadletQuota,
  AtPadletQuota,
  OverPadletQuota,
  OverFileSizeQuota,
  SchedulePro,
  ConfirmProMonthly,
  ConfirmProAnnual,
}

interface PlansState {
  plans: {
    platinum: { annual: {} | Plan; monthly: {} | Plan }
    gold: { annual: {} | Plan; monthly: {} | Plan }
  }
  xUpgradeModal: boolean
  upgradeStep: UpgradeStep | null
}

const blankState = (): PlansState => ({
  plans: {
    platinum: { annual: {}, monthly: {} },
    gold: { annual: {}, monthly: {} },
  },
  xUpgradeModal: false,
  upgradeStep: null,
})

const PlansModule: Module<PlansState, object> = {
  namespaced: true,
  state: blankState,
  getters: {
    xUpgradeModal: (state) => state.xUpgradeModal,
    upgradeStep: (state) => state.upgradeStep,
    plans: (state) => state.plans,
    plansFetched: (state) => Object.keys(state.plans.platinum.annual).length !== 0,
  },
  mutations: {
    FETCHED_PLANS(state, plans: Plan[]) {
      // Convert a list to a hash that is easy to use in our component
      const hashedPlans = {
        platinum: { annual: {}, monthly: {} },
        gold: { annual: {}, monthly: {} },
      }
      for (const plan of plans) {
        hashedPlans[plan.tier][plan.period] = plan
      }
      state.plans = hashedPlans
    },
    SHOW_PLAN_UPGRADE_MODAL(state, step: UpgradeStep): void {
      state.xUpgradeModal = true
      state.upgradeStep = step
    },
    HIDE_PLAN_UPGRADE_MODAL(state): void {
      state.xUpgradeModal = false
      state.upgradeStep = null
    },
  },
  actions: {
    async fetchPlans({ commit }): Promise<void> {
      const response = await PlanApi.fetch()
      commit('FETCHED_PLANS', response.data)
    },
    showPlanUpgradeModal({ commit }, step: UpgradeStep): void {
      commit('SHOW_PLAN_UPGRADE_MODAL', step)
    },
    hidePlanUpgradeModal({ commit }): void {
      commit('HIDE_PLAN_UPGRADE_MODAL')
    },
  },
}

export default PlansModule
export { UpgradeStep }
